// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UHhQ","top":"styles_top__HweRM","left":"styles_left__39NHi","description":"styles_description__34umn"};